// extracted by mini-css-extract-plugin
export default {"bannerDeletePresetDialog":"DeletePresetDialog-module__bannerDeletePresetDialog--XbHtn"};